var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Slices',{attrs:{"slices":_vm.document.data.body,"document":_vm.document}}),_vm._v(" "),_c('AuthorBox',{attrs:{"document":_vm.document}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }